/** Foundation · Sequence — pannello "Vai al successivo / Rimani / Torna" dopo il completamento. */
import React from "react";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SuiteButton } from "@/components/suite";

export function NextSubjectPanel({ open, onOpenChange, title, summary, state, nameOf, currentName, onNext, onStay, onReturn, returnLabel, testid = "next-subject-panel" }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-emerald-700"><CheckCircle2 size={18} /> {title}</DialogTitle>
          <DialogDescription>{summary}</DialogDescription>
        </DialogHeader>
        <div className="text-xs text-suite-neutral-500" data-testid={`${testid}-progress`}>{state.completed} / {state.total} completati</div>
        <div className="flex flex-col gap-2">
          {state.next ? (
            <SuiteButton autoFocus iconRight={ArrowRight} onClick={onNext} data-testid={`${testid}-next`}>Vai a {nameOf(state.next)}</SuiteButton>
          ) : (
            <div className="rounded-md bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid={`${testid}-all-done`}>Tutti completati per questo periodo.</div>
          )}
          <SuiteButton variant="secondary" onClick={onStay} data-testid={`${testid}-stay`}>Rimani su {currentName}</SuiteButton>
          <SuiteButton variant="ghost" onClick={onReturn} data-testid={`${testid}-return`}>{returnLabel}</SuiteButton>
        </div>
        {state.next && <div className="text-[11px] text-suite-neutral-400">Premi Invio per proseguire</div>}
      </DialogContent>
    </Dialog>
  );
}

export default NextSubjectPanel;
